import { vmFacebookShareModal } from './../components';

/**
 * フォローした企業のシェアを誘導するモーダルを表示
 *
 * @param {string} companyId 企業ID
 */
export function popupShareThisCompany (companyId) {
  vmFacebookShareModal.$data.companyId = companyId;
  vmFacebookShareModal.$data.isShow = true;
}
